export const perguntas = {
    1: {
        id: 1,
        desc: "Título",
        peso: 1,
        pesoDesempate: 10
    },
    2:{
        id: 2,
        desc: "História diagnóstica do paciente com FC",
        peso: 1,
        pesoDesempate: 100,
    },
    3:{
        id: 3,
        desc: "Relato do caso clínico",
        peso: 3,
        pesoDesempate: 10000,
    },
    4:{
        id: 4,
        desc: "Discussão e conclusão",
        peso: 2,
        pesoDesempate: 1000,
    },
    5:{
        id: 5,
        desc: "Imagens e/ou resultados de exames",
        peso: 3,
        pesoDesempate: 100,
    },
    6:{
        id: 6,
        desc: "Referência bibliográfica",
        peso: 1,
        pesoDesempate: 1,
    }
}

// export const disclaimer = 'Este site (o "Website"), acessado, é projetado exclusivamente para médicos e outros profissionais de saúde. Por favor, note que este site pode conter informações sobre produtos farmacêuticos que somente podem ser vendidos sob receita médica. De acordo com a lei brasileira, a promoção e publicidade desses produtos é restrita aos profissionais de saúde. O site contém informações destinadas exclusivamente a profissionais de saúde, portanto, é da exclusiva responsabilidade do usuário apresentar informações verdadeiras sobre os dados fornecidos e sobre o fato de exercerem profissionalmente alguma profissão que os enquadre como profissionais de saúde. Se você não é um profissional de saúde, solicitamos que abandone imediatamente a página e evite a navegação. A Merck S.A. não é responsável pelas consequências que a informação aqui publicada pode gerar no visitante que não seja profissional da saúde ou, através deste, em terceiros. As possíveis consequências da utilização desta informação sem consultar um profissional de saúde representam sérios riscos para à vida e à saúde. A Merck S.A. reserva-se o direito de revogar a senha no caso da informação não ser confiável. '
export const disclaimer = `
BR-28-2500173 – Material destinado a profissionais habilitados a prescrever e/ou dispensar medicamentos.
Os eventos adversos deverão ser relatados à farmacovigilância da VERTEX pelo e-mail medicalinfoLATAM@vrtx.com ou telefone 0800 047 4048.
<br />
TRIKAFTA® (elexacaftor/tezacaftor/ivacaftor + ivacaftor)
<br />
Indicações:
TRIKAFTA® é indicado para o tratamento da fibrose cística (FC) em pacientes com 6 anos de idade ou mais que tenham pelo menos uma mutação F508del no gene regulador de condutância transmembrana da fibrose cística (CFTR) ou uma mutação no gene CFTR que seja responsiva com base em dados clínicos e/ou in vitro (para mais informações, consulte na bula aprovada as seções 2. Resultados de Eficácia e 3. Características Farmacológicas).

Contraindicações:
Não tome TRIKAFTA® se você é alérgico a elexacaftor, tezacaftor, ivacaftor, ou qualquer outro ingrediente deste medicamento.

Cuidados e Advertências:
Foi reportado um caso de insuficiência hepática cujo paciente com cirrose e hipertensão portal durante o tratamento com TRIKAFTA® necessitou de transplante. TRIKAFTA® deve ser utilizado com precaução por pacientes com doença hepática avançada pré-existente e somente se for esperado que os benefícios superem os riscos. Se utilizado por estes pacientes, os mesmos devem ser monitorados após o início do tratamento. Transaminases elevadas são comuns em pacientes com FC e foram observadas em alguns pacientes tratados com TRIKAFTA®. Em alguns casos, essas elevações foram associadas com concomitante elevação da bilirrubina total. Avaliações de transaminases (ALT e AST) e de bilirrubina total são recomendadas para todos os pacientes antes de iniciar o tratamento com TRIKAFTA®, a cada mês durante os primeiros 6 meses, a cada 3 meses durante os próximos 6 meses e anualmente após esse período. Para pacientes com histórico de doença hepática ou elevações de transaminase, deve-se considerar monitoramento mais frequente.
Erupção cutânea: A incidência de erupções cutâneas foi maior em mulheres do que em homens, particularmente em mulheres que tomavam anticoncepcionais hormonais.
Interações com medicamentos: A exposição ao IVA é significativamente diminuída e as exposições ao ELX e ao TEZ podem ser reduzidas pelo uso concomitante de indutores CYP3A, potencialmente resultando na redução da eficácia de TRIKAFTA®; portanto, a administração concomitante com potentes indutores CYP3A não é recomendada. A dose de TRIKAFTA® deve ser reduzida quando usado concomitantemente com inibidores moderados ou potentes de CYP3A.
Catarata: São recomendados exames oftalmológicos iniciais e de acompanhamento em pacientes pediátricos iniciando o tratamento com TRIKAFTA®.
Efeitos na capacidade de dirigir veículos e operar máquinas: Os pacientes que apresentarem tonturas enquanto estiverem fazendo uso de TRIKAFTA® devem ser aconselhados a não dirigir ou operar máquinas até os sintomas diminuírem.
Fertilidade, Gravidez e lactação: Não foram conduzidos estudos adequados e bem controlados de TRIKAFTA® em grávidas. Em razão de os estudos de reprodução animal nem sempre serem preditivos da resposta humana, TRIKAFTA® deve ser usado durante a gravidez apenas se os potenciais benefícios superarem os potenciais riscos.

Reações adversas muito comuns:
- dor de cabeça, infecção das vias respiratórias superiores, dor de estômago, diarreia, erupção cutânea, níveis elevados de enzimas do fígado no sangue.

Reações adversas comuns:
- congestão nasal, aumento da enzima sanguínea chamada creatina fosfoquinase, rinorreia, rinite, sinusite, gripe (influenza), aumento de bilirrubina no sangue, flatulência, distensão abdominal, conjuntivite, faringite e amigdalite, infecção nas vias respiratórias, infecção urinária, proteína C reativa aumentada, hipoglicemia, tontura, cólicas menstruais, espinhas no rosto, pele com coceira e inflamada.

Posologia:
Adultos e pacientes pediátricos com 6 anos de idade ou mais devem ser tratados de acordo com a tabela abaixo.
<br />
Recomendação de dosagem para pacientes com 6 anos ou mais:
<table style="margin: 16px auto; border-collapse: collapse;" border="1" cellpadding="8" cellspacing="0">
  <thead>
    <tr>
      <th>Idade</th>
      <th>Dose da manhã (2 comprimidos)</th>
      <th>Dose da noite (1 comprimido)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>6 a &lt;12 anos, &lt;30 kg</td>
      <td>50 mg elexacaftor / 25 mg tezacaftor / 37,5 mg ivacaftor</td>
      <td>ivacaftor 75 mg</td>
    </tr>
    <tr>
      <td>6 a &lt;12 anos, ≥30 kg</td>
      <td>100 mg elexacaftor / 50 mg tezacaftor / 75 mg ivacaftor</td>
      <td>ivacaftor 150 mg</td>
    </tr>
    <tr>
      <td>≥12 anos</td>
      <td>100 mg elexacaftor / 50 mg tezacaftor / 75 mg ivacaftor</td>
      <td>ivacaftor 150 mg</td>
    </tr>
  </tbody>
</table>

As doses matinal e noturna devem ser ingeridas com alimentos contendo gordura, com aproximadamente 12 horas de intervalo entre elas. Via oral.

MS: 1.3823.0005
VENDA SOB PRESCRIÇÃO MÉDICA
MB_Trikafta_30/04/25
`;